

import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import AppLayout from '../../components/AppLayout';

const UnderDevelopment: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AppLayout>
    <div style={{ padding: '2rem', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh' }}>
      <Result
        status="info"
        title="This page is under development"
        subTitle="We're working hard to bring this feature to you soon."
        extra={
          <Button type="primary" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        }
      />
    </div>

    </AppLayout>
  );
};

export default UnderDevelopment;